import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import Text from "components/Text";
import { useCurrentTenant } from "contexts/currentTenant";
import { now } from "utils/time";

import styles from "./Disclaimers.scss";

const FinalDecision = ({ municipalityType }) => (
  <div className={styles.section}>
    <Text
      t="pages.home.final_decision"
      municipalityTypeLowerCase={municipalityType.toLowerCase()}
    />
  </div>
);

FinalDecision.propTypes = {
  municipalityType: PropTypes.string.isRequired,
};

const ADACompliance = () => (
  <div className={styles.section}>
    <Text t="pages.home.ada_compliance" />
  </div>
);

const Copyright = () => (
  <div className={styles.section}>{`© ${now().format("YYYY")} Open Counter Enterprises Inc.`}</div>
);

const Disclaimers = () => {
  const { municipality_type: municipalityType, disclaimer } = useCurrentTenant();
  return (
    <div className={styles.container}>
      <div>
        <div className={styles.line} />
        <div className={styles.content}>
          {disclaimer ? (
            <div className={classnames(styles.disclaimers, styles.section)}>{disclaimer}</div>
          ) : (
            <FinalDecision municipalityType={municipalityType} />
          )}
          <ADACompliance />
          <Copyright />
        </div>
      </div>
    </div>
  );
};

export default Disclaimers;
